import { InputComponent } from '../../../../shared/components/input/input.component';
import { FormGroup, FormControl } from '@angular/forms';
import { ArticleBlock, ArticleImage, CarouselData } from '../../../../models/article';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-article-image',
  templateUrl: './article-image.component.html',
  styleUrls: ['./article-image.component.scss'],
})
export class ArticleImageComponent implements OnInit {

  @ViewChild('fileInput') fileInputComponent: InputComponent;

  @Output() blockElementChange = new EventEmitter<ArticleBlock>();

  @Input() isFromEditor: boolean = false;

  @Input() set blockElement(value: ArticleBlock) {
    this._blockElement = value;
    if (this.blockElement.data) {
      const carouselData = JSON.parse(this.blockElement.data);
      if (carouselData.Images?.length) {
        this.imageUrlList = carouselData.Images;
      } else {
        this.imageUrlList = [];
        this.blockElement.images?.forEach(x => {
          this.imageUrlList.push(this.fileToBlobUrl(x.image));
        });
      }
      this.blockElement.layout = carouselData.Layout;
    } else {
      this.imageUrlList = ['', '', '', ''];
    }
  }

  @Input() stopAnimation: boolean = false;

  get blockElement() {
    return this._blockElement;
  }

  private _blockElement: ArticleBlock;

  imageCount: number = 0;
  //imageLayoutType = ImageLayoutType;

  imageUrlList: string[] = ['', '', '', ''];
  formGroup = new FormGroup({
    Image1: new FormControl(''),
    Image2: new FormControl(''),
    Image3: new FormControl(''),
    Image4: new FormControl(''),
  });

  get isAllImageThere() {
    return this.imageUrlList?.some((x) => !x);
  }

  constructor(private toastr: ToastrService,
  ) { }
  ngOnInit(): void { }


  onClick(fileInput: any) {
    if (this.blockElement.isActiveForEdit) {
      fileInput.onFileUpload();
    }
  }

  swapImages(event: MouseEvent): void {
    if (this.isFromEditor || this.blockElement.layout != 1) {
      return;
    }
    const target = event.target as HTMLImageElement;
    const smallImgSrc = target.getAttribute('src');
    if (smallImgSrc) {
      const bigImg = document.querySelector('.big-img') as HTMLImageElement;
      if (bigImg) {
        const bigImgSrc = bigImg.src;
        bigImg.src = smallImgSrc;
        target.src = bigImgSrc;
      }
    }
  }

  onFileSelected(event: any, index: number) {
    const file = event.target.files[0];
    if (file) {
      if (!file.type?.startsWith("image/")) {
        this.toastr.error('Please select a image.');
        return;
      }
      this.blockElement.images = this.blockElement.images ?? [];
      this.blockElement.images[index] = { image: file } as ArticleImage;
      const reader = new FileReader();
      reader.onload = () => {
        this.imageUrlList[index] = this.fileToBlobUrl(file);
        this.blockElement.imageCount = this.imageUrlList.filter(x => x).length;
        this.blockElement.data = JSON.stringify({ Images: this.imageUrlList, Layout: this.blockElement.layout } as CarouselData);
        this.blockElementChange.emit(this.blockElement);
      };
      reader.readAsDataURL(file);

    }
  }

  fileToBlobUrl(file) {
    const blob = new Blob([file], { type: file.type });
    return URL.createObjectURL(blob);
  }

  close(e: any) {
    this.blockElement.isActiveForEdit = false;
  }
}
